import { render, staticRenderFns } from "./BrandStatistics.vue?vue&type=template&id=7dd52e49&scoped=true&"
import script from "./BrandStatistics.vue?vue&type=script&lang=js&"
export * from "./BrandStatistics.vue?vue&type=script&lang=js&"
import style0 from "./BrandStatistics.vue?vue&type=style&index=0&id=7dd52e49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd52e49",
  null
  
)

export default component.exports